import { setup_ajax, update_side_feed } from "./helpers";
setup_ajax();

var follow_template = require("./../templates/small-follow.handlebars");

function trackEvent(eventType, sourceSurface, url, postId) {
  fetch("/api/analytics/track_event", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      event_type: eventType,
      post_id: postId === undefined ? page_params.post_id : postId,
      source_surface: sourceSurface,
      target_url: url,
    }),
    keepalive: true,
  }).catch(function () {});
}

$(function () {
  $(document).on("click", "a[target='_blank']", function () {
    trackEvent("post_outbound_click", "post_page", this.href);
  });

  // Clicks into the "More posts like this" list — the multi-post session signal.
  $(document).on("click", ".similar-post-link", function () {
    trackEvent("link_click", "similar_posts", this.href, $(this).data("post-id"));
  });

  $(document).on("click", ".similar-post-topic-link", function () {
    trackEvent("topic_sidebar_click", "similar_posts_topic", this.href);
  });

  $("#discover-more-posts-link").on("click", function () {
    trackEvent("link_click", "similar_posts_discover", this.href);
  });

  $("#follow_list").html(follow_template(page_params.posted_by));

  $.get("/api/posts/user", {
    username: page_params.posted_by.username,
    limit: 5,
  }).done(function (posts) {
    if (posts.length !== 0) {
      $("#recent_posts_from_author_section").removeClass("hidden");
      update_side_feed($("#recent_posts_from_author"), posts);
    }
  });
});
